import React from "react";

const RULES = [
  [5, "Exact score", "Pick 2–1, ends 2–1"],
  [3, "Right goal difference or draw", "Pick 2–1, ends 3–2"],
  [2, "Right result", "Pick 2–1, ends 3–0"],
  [1, "One team's score right", "Pick 2–1, ends 2–3"],
];

export const SCORING_CHIPS = [
  [5, "exact"],
  [3, "GD or draw"],
  [2, "result"],
  [1, "one team"],
];

export function ScoringChips({ className = "" }) {
  return (
    <p className={`text-[13px] leading-relaxed text-muted ${className}`}>
      {SCORING_CHIPS.map(([pts, label], i) => (
        <span key={pts}>
          {i > 0 && <span aria-hidden> · </span>}
          <span className="tabular-nums font-semibold text-ink">{pts}</span> {label}
        </span>
      ))}
    </p>
  );
}

export default function ScoringGuide() {
  return (
    <section className="rounded-xl border border-line bg-white shadow-sm overflow-hidden">
      <h2 className="px-4 py-3 border-b border-gray-100 text-[15px] font-semibold text-ink">How points work</h2>
      <ul className="divide-y divide-gray-100">
        {RULES.map(([pts, label, example]) => (
          <li key={pts} className="flex items-center gap-3 px-4 py-2.5">
            <span
              className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-sm font-bold tabular-nums ${
                pts === 5 ? "bg-green-600 text-white" : pts >= 2 ? "bg-amber-100 text-amber-900" : "bg-gray-100 text-gray-700"
              }`}
            >
              {pts}
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-ink">{label}</span>
              <span className="block text-[12px] text-muted">{example}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
